import { $ } from "js/vendor";

export default function setCursor(cursor) {
    $("html,body").css("cursor", cursor);
}
